import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import more from 'highcharts/highcharts-more'

more(Highcharts)

const SpeedAndDistanceChart = ({
  options,
  radioLabels,
  type,
  handleTypeChange,
}) => {
  const onSpeedOrDistance = () => {
    handleTypeChange()
  }
  return (
    <div className="block ">
      <div className="level">
        <div className="level-left">
          <div className="level-item"></div>
        </div>
        <div className="level-center">
          <div className="level-item"></div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <div className="control">
              <label className="radio pr-3">
                <input
                  type="radio"
                  name="speedOrDistance"
                  onChange={() => onSpeedOrDistance('speed')}
                  checked={type === 'speed'}
                />
                {' ' + radioLabels[0]}
              </label>
              <label className="radio">
                <input
                  type="radio"
                  name="speedOrDistance"
                  onChange={() => onSpeedOrDistance('distance')}
                  checked={type === 'distance'}
                />
                {' ' + radioLabels[1]}
              </label>
            </div>
          </div>
        </div>
        {/* <div className="level-right">
          <div className="level-item">
            <label className="checkbox">
              <input
                type="checkbox"
                checked={checked}
                onChange={handleCumulClick}
              />
              {choosenLang.cumulate}
            </label>
          </div>
        </div> */}
      </div>

      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </div>
  )
}

export default SpeedAndDistanceChart
